import { rule } from '../../domain/badge-composition-rule.js';

export const computeConstraintsRules = composition => {
  const { check, stateIsMaximized } = composition.checkers;

  return [
    rule('computed/constraint/canMaximize')
      .when(check(() => composition.constraints.alwaysMaximized))
      .set(() => ({
        constraints: {
          canMaximize: false
        }
      })),

    rule('computed/aspect/type')
      .when(check(() => composition.constraints.canMaximize && stateIsMaximized() || composition.constraints.alwaysMaximized))
      .set(() => ({
        aspect: {
          type: 'expanded'
        }
      })),
  ];
};
